import classNames from 'classnames';
import React, { useState } from 'react';
import * as styles from './TeamButton.module.scss';
import TeamMenu from './TeamMenu';
import useAppSelector from '../app/redux/useAppSelector';
import Button from '../components/Button';
import Caret from '../components/Caret';
import PopOver from '../components/deprecated/PopOver';
import TeamIcon from '../organization/TeamIcon';
import Link from '../utils/router/Link';

const TeamButton = () => {
  const [isPopOverOpen, setIsPopOverOpen] = useState(false);
  const name = useAppSelector((state) => state.session.organization.name);

  return (
    <div className={styles.teamButton}>
      <Link className={styles.logoContainer} to="/">
        <TeamIcon />
      </Link>
      <PopOver
        display="inline-block"
        popOver={<TeamMenu />}
        placement="bottom-start"
        popOverPortal={document.body}
        responsivePlacement="bottom"
        trigger="click"
        open={isPopOverOpen}
        onOpenChange={setIsPopOverOpen}
      >
        <Button
          className={classNames(styles.orgName, {
            [styles.isPopOverOpen]: isPopOverOpen,
          })}
        >
          <span className={styles.orgNameText}>{name}</span>
          <Caret />
        </Button>
      </PopOver>
    </div>
  );
};

export default TeamButton;
